import { SortDirections } from "app/ApiClient";

export function sortString(s1: string | undefined, s2: string | undefined, direction?: SortDirections): number {
  let a = s1;
  let b = s2;
  if (direction === SortDirections.Desceding) {
    a = s2;
    b = s1;
  }
  if (a && b) {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }
  if (a && !b) {
    return 1;
  }
  if (b && !a) {
    return -1;
  }
  return 0;
}
